// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContentBubble_container__roTVR {
  position: absolute;
  padding: 1rem;
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.5));
  transition: all 0.4s ease;
}

.ContentBubble_bubble__IG3sa {
  background-color: white;
  padding: 1rem;
  border-radius: 8px;
}

.ContentBubble_triangle__NlZtN {
  position: absolute;
  transform-origin: 50% 50%;
}
.ContentBubble_triangle__NlZtN div {
  width: 3rem;
  height: 3rem;
  background-color: white;
  clip-path: polygon(0% 50%, 50% 0%, 100% 50%);
}`, "",{"version":3,"sources":["webpack://./src/components/ContentBubble/ContentBubble.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mDAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,4CAAA;AACJ","sourcesContent":[".container {\n  position: absolute;\n  padding: 1rem;\n  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.5));\n  transition: all 0.4s ease;\n}\n\n.bubble {\n  background-color: white;\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.triangle {\n  position: absolute;\n  transform-origin: 50% 50%;\n}\n.triangle div {\n  width: 3rem;\n  height: 3rem;\n  background-color: white;\n  clip-path: polygon(0% 50%, 50% 0%, 100% 50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ContentBubble_container__roTVR`,
	"bubble": `ContentBubble_bubble__IG3sa`,
	"triangle": `ContentBubble_triangle__NlZtN`
};
export default ___CSS_LOADER_EXPORT___;
